import { IsValueNull } from "../../Common/IsValueNull";
import userService from "../../services/user.service";
import { ActionTypes } from "../Constants/ActionTypes";
import handleTrim from "../../component/schoolAdminPortal/Video Highlights/services/handleTrim";

export const setIntercutVideoData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RENAME_INTERCUT_LOADING,
    payload: true,
  });
  userService
    .getPlayListData(
      payload.schoolId,
      payload.seasonName,
      payload.seasonType,
      IsValueNull(payload.eventType),
      IsValueNull(payload.eventName),
      IsValueNull(payload.practiceName),
      IsValueNull(payload.opponentName),
      payload.playlistId
    )
    .then((res) => {
      const { totalVideoCount, intercutDetailsResponse } = res.data.data;

      let angleCount = 0;

      for (let index = 0; index < intercutDetailsResponse.length; index++) {
        if (intercutDetailsResponse[index].eventMedia.length) {
          angleCount++;
        }
      }

      dispatch({
        type: ActionTypes.SET_INTERCUT_VIDEO_LIST,
        payload: {
          endZonarData: intercutDetailsResponse[0].eventMedia,
          endZonalData: intercutDetailsResponse[1].eventMedia,
          wideAngleData: intercutDetailsResponse[2].eventMedia,
          tightAngleData: intercutDetailsResponse[3].eventMedia,
          otherAngleData: intercutDetailsResponse[4].eventMedia,
          totalVideoCount: totalVideoCount,
          angleCount: angleCount,
        },
      });
      dispatch({
        type: ActionTypes.RENAME_INTERCUT_LOADING,
        payload: false,
      });
    });
};

export const setInterCutVideoDataAfterDragAndDrop = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_INTERCUT_VIDEO_LIST_AFTER_DRAG_AND_DROP,
    payload: payload,
  });
};

export const replaceEditedIntercutVideo = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.REPLACE_EDITED_INTERCUT_VIDEO_LOADING,
    payload: true,
  });
  const { startTime, duration } = payload;
  const { angleName, listName } = payload?.videoEditPopupData;
  const { videoPath, eventMediaCategory, id } =
    payload?.videoEditPopupData?.videoData;
  const fName = `${eventMediaCategory.split(".")[0] + Date.now() + ".mp4"}`;
  handleTrim(startTime, duration, fName, videoPath)
    .then((response) => {
      const { filePath, videoDuration, fileSize, fileName } = response?.data;
      userService
        .updateMediaVideoUrl(
          id,
          filePath,
          videoDuration,
          fileSize,
          eventMediaCategory
        )
        .then((res) => {
          const data = {
            videoPath: res.data?.data[0].videoPath,
            angleName,
            listName,
            id,
            videoDuration,
          };
          dispatch({
            type: ActionTypes.REPLACE_EDITED_INTERCUT_VIDEO,
            payload: data,
          });
          dispatch({
            type: ActionTypes.OPEN_VIDEO_EDIT_POPUP,
            payload: false,
          });
          dispatch({
            type: ActionTypes.OPEN_SUCCESS_POPUP,
            payload: {
              successPopUp: {
                message: "Video Edited Successfully",
                open: true,
              },
            },
          });
          dispatch({
            type: ActionTypes.REPLACE_EDITED_INTERCUT_VIDEO_LOADING,
            payload: false,
          });
        })
        .catch((error) => {
          dispatch({
            type: ActionTypes.OPEN_VIDEO_EDIT_POPUP,
            payload: false,
          });
          dispatch({
            type: ActionTypes.OPEN_FAIL_DIALOG,
            payload: {
              open: true,
              message: "Something Went Wrong",
            },
          });
        });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.REPLACE_EDITED_INTERCUT_VIDEO_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_VIDEO_EDIT_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const renameIntercutVideo = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RENAME_VIDEO_LOADING,
    payload: true,
  });
  userService
    .renameVideo(payload.id, payload.videoName, payload.schoolId)
    .then(() => {
      dispatch({
        type: ActionTypes.RENAME_VIDEO_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_RENAME_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.RENAME_INTERCUT_VIDEO,
        payload: payload,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.RENAME_VIDEO_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_RENAME_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const deleteIntercutVideo = (dispatch, payload) => {
  userService
    .deleteEditedVideos([payload.id])
    .then((res) => {
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Video Deleted Successfully",
            open: true,
          },
        },
      });
      dispatch({
        type: ActionTypes.DELETE_INTERCUT_VIDEO,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const setVideoPlayInformation = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_VIDEO_PLAY_INFORMATION,
    payload: payload,
  });
};
